import { create } from "zustand"

import { localStorageItems } from "../../util/storage"

interface FirstQuestCompleteModalStoreProps {
  isOpen: boolean
  onOpen: (name?: string) => void
  onClose: () => void
  name: string | null
}

export const useFirstQuestCompleteModalStore =
  create<FirstQuestCompleteModalStoreProps>((set) => ({
    isOpen: false,
    onOpen: (name) => {
      const hasMarkedFirstQuestComplete = !!localStorage.getItem(
        localStorageItems.hasMarkedFirstQuestComplete
      )
      if (hasMarkedFirstQuestComplete) return
      localStorage.setItem(
        localStorageItems.hasMarkedFirstQuestComplete,
        "true"
      )
      set({ isOpen: true, name: name ?? null })
    },
    onClose: () => set({ isOpen: false }),
    name: null,
  }))
